import styled from "styled-components";

export default styled.div`
  .MuiInputBase-input {
    padding-left: 1rem;
    width: 150px;
    padding-left: 0px;
    padding-right: 0px;

    &:hover {
      box-shadow: none !important;
    }
  }
`;
